"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationRequest = void 0;
var file_1 = require("../../../library/file");
var VerificationRequest = /** @class */ (function () {
    function VerificationRequest() {
        this.file = new file_1.File();
    }
    return VerificationRequest;
}());
exports.VerificationRequest = VerificationRequest;
;
//# sourceMappingURL=verification.request.js.map